/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Teams_Is_ActiveInputs */

const en_tables_teams_is_active = /** @type {(inputs: Tables_Teams_Is_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Active`)
};

const de_tables_teams_is_active = /** @type {(inputs: Tables_Teams_Is_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Aktiv`)
};

/**
* | output |
* | --- |
* | "Is Active" |
*
* @param {Tables_Teams_Is_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_teams_is_active = /** @type {((inputs?: Tables_Teams_Is_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Teams_Is_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_teams_is_active(inputs)
	return de_tables_teams_is_active(inputs)
});